import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { Status } from '@/models/status.model';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import EdCreateProductComponent from '@/courses/components/ed-create-product/ed-create-product.component.vue';
import { COURSE_TEMPLATE_EVENTS, PRODUCT_TYPES } from '@/course-templates/values/course-templates.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { ClassesService } from '@/classes/services/classes.service';
import { CLASSES_STORE } from '@/classes/store/classes.store';
import { COURSE_STORE } from '@/courses/values/courses.values';
import { _COURSE_STORE } from '@/courses/enums/courses.enum';

@Component({
  name: 'ed-create-quick-subject',
  components: {
    EdCreateProduct: EdCreateProductComponent
  }
})
export default class EdCreateQuickSubjectComponent extends Vue {

  @Prop() readonly params: any;
  
  public status: Status = new Status(); 
  public template: any = {};
  public productType: any = PRODUCT_TYPES.BUILDER;
  public disabledSubjectForm: boolean = false;
  public subject: any = {};

  get templateId () {
    return this.params.templateId;
  }

  get classId () {
    return this.params.classId;
  }

  get quickSubjectId () {
    return this.params.quickSubjectId;
  }

  closeModal() {
    this.params.resetModal();
    this.$EdModal.closeModal();
  }

  get title() {
    return this.quickSubjectId ? this.$t('classes.courses.updateQuickSubject') : this.$t('classes.courses.addQuickSubject')
  }

  saveSubjectDescriptionClick() {
    this.$edEventBus.$emit(COURSES_EVENTS.SUBJECT_DESCRIPTION_BUILDER);
  }
  
  async saveSubjectDescription({formData, uploadedImage}) {
    try {
      this.status.setLoading();
      this.subject = {
        ...formData,
        title: formData.contentTitle,
        img: formData.coverImageUrl,
        defaultDueDateForTasks: formData.defaultDueDateForTasks,
        defaultLastDateForTasks: formData.defaultLastDateForTasks,
        contentSummary: formData.contentSummary,
        imgHash: formData.coverImg,
        actualGrade: formData.actualGradeId,
        suggestedGrade: formData.suggestedGradeId
      };
      let req = {
        templateId: this.templateId || this.template.templateId, 
        classId: this.classId,
        schoolDay: this.template.schoolDay,
        subject: this.subject,
        coverImage: uploadedImage?.file,
        automaticFolderType: formData.automaticFolderType,
        componentsSelected: formData.componentsSelected
      }
      if(this.quickSubjectId) req['quickContentId'] = this.quickSubjectId;
      const response = await this.$store.dispatch(this.quickSubjectId ? CLASSES_STORE.ACTIONS.UPDATE_QUICK_CONTENT_A : CLASSES_STORE.ACTIONS.CREATE_QUICK_CONTENT_A, req);
      if(!this.quickSubjectId) 
        await this.$Builder.Services.getTemplatesStructureById(response.contentId);
      
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.success.quickSubjectSaved')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.status.setLoad();
    } catch(err) {
      this.status.setError();
      this.$EdToast.create({ 
        msg:  `${this.$t('classes.errors.errorSavingQuickSubject')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
    this.closeModal();
  }

  public async getTemplateDescription() {
    try {
      let res = await ClassesService.getCourseTemplateByClass(this.templateId, this.classId);
      this.template = {
        id: res.contentId,
        title: res.contentTitle,
        img: res.coverThumbnailSmallUrl,
        defaultDueDateForTasks: res.defaultDueDateForTasks,
        defaultLastDateForTasks: res.defaultLastDateForTasks,
        contentSummary: res.contentSummary,
        categoryId: res.category.id,
        imgHash: res.coverImg,
        hasGrading: res.hasGrading,
        actualGrade: res.actualGrade,
        suggestedGrade: res.suggestedGrade,
        duration: res.duration,
        components: res.components,
        schoolDay: res.schoolDay,
        automaticFolderType: res.automaticFolderType
      }
    } catch (err){      
      this.closeModal();
      this.$EdToast.create({ 
        msg:  `${this.$t('courseTemplates.errors.errorLoadingCourseTemplate')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  async getQuickContentDescription() {
    try {
      let res = await ClassesService.getQuickContent(this.templateId, this.quickSubjectId);
      this.template = {
        id: res.subject.contentId,
        title: res.subject.contentTitle,
        img: res.subject.coverThumbnailSmallUrl,
        defaultDueDateForTasks: res.subject.defaultDueDateForTasks,
        defaultLastDateForTasks: res.subject.defaultLastDateForTasks,
        contentSummary: res.subject.contentSummary,
        categoryId: res.subject.category.id,
        imgHash: res.subject.coverImg,
        hasGrading: res.subject.hasGrading,
        actualGrade: res.subject.actualGrade,
        suggestedGrade: res.subject.suggestedGrade,
        components: res.subject.components,
        componentsSelected: res.componentsSelected,
        schoolDay: res.schoolDay,
        templateId: res.templateId,
        automaticFolderType: res.automaticFolderType
      } 
    }
    catch {
      this.$EdToast.create({ 
        msg:  `${this.$t('courses.errors.errorLoadingCourse')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  mounted() {
    this.$edEventBus.$on(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM, this.saveSubjectDescription);
    this.quickSubjectId ? this.getQuickContentDescription() : this.getTemplateDescription();
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM);
  }

}